<template>
  <div class="skunav" :class="containerClass">
    <h5>Your Custom SKU</h5>

    <nav class="sku">
      <span>{{ product.family }}</span>
      <span>{{ product.model }}</span>
      <span>{{ product.type }}</span>

      <button
        v-for="(step, index) in steps"
        type="button"
        :key="`step-${index}-${step.id}`"
        :disabled="!canSkipThisStep(step)"
        :class="{ active: pointer === index, disabled: !canSkipThisStep(step) }"
      >
        <span class="value">
          {{ evaluateStepValue(step) }}
        </span>
        <span class="number" :class="{ disabled: !canSkipThisStep(step) }">
          <i>{{ calculateStepNumberFromArrayIndex(index) }}</i>
        </span>
      </button>
    </nav>
  </div>
</template>

<script>
export default {
  props: ["product", "pointer", "selections"],
  computed: {
    steps() {
      return this.product.steps || [];
    },
    containerClass() {
      let size = this.steps.length >= 9 ? "small" : "large";
      return this.steps.length <= 8 && this.steps.length >= 5 ? "med" : size;
    },
  },
  methods: {
    canSkipThisStep(step) {
      /* kill step-skipping for now */
      return false;
    },
    calculateStepNumberFromArrayIndex(index) {
      return index + 1;
    },
    evaluateStepValue(step) {
      const selection = this.selections[step.id];

      if (!selection) {
        return "???";
      }

      return selection.external || selection;
    },
  },
};
</script>
